(function () {
  const UID = 'geo3d-main';

  let LAST_GPX = null;

  function killGhostGeo3DJson() {
    const all = document.querySelectorAll('#Geo3DJson');
    if (all.length <= 1) return;

    const real = document.querySelector('product-form form #Geo3DJson');

    all.forEach((el) => {
      const isGhost = !el.closest('product-form form') && el.getAttribute('form');
      if (isGhost) el.remove();
      if (real && el !== real && el.id === 'Geo3DJson') el.remove();
    });
  }

  function numOr(value, fallback) {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function buildFinalPayload(p) {
    if (!p) return null;

    const kmValue = typeof p.km !== 'undefined' ? Number(p.km) : 0;

    const payload = {
      uid: p.uid || UID,
      bounds: p.bounds || null,
      zoom: typeof p.zoom !== 'undefined' ? p.zoom : null,
      km: Number.isFinite(kmValue) ? kmValue : 0,
      exaggeration: typeof p.exaggeration !== 'undefined' ? Number(p.exaggeration) : 1,
      meshColor: p.meshColor || null,
      trackColor: p.trackColor || null,

      // conservar valores del frontend / variante actual
      // pero forzar grid alto en producción/pedido final
      tileZoom: typeof p.tileZoom !== 'undefined' && p.tileZoom !== null ? Number(p.tileZoom) : 14,
      grid: 1024,
      sizeMm: typeof p.sizeMm !== 'undefined' && p.sizeMm !== null ? Number(p.sizeMm) : 114,
      baseMm: typeof p.baseMm !== 'undefined' && p.baseMm !== null ? Number(p.baseMm) : 6,
      zMmPerM: typeof p.zMmPerM !== 'undefined' && p.zMmPerM !== null ? Number(p.zMmPerM) : 0.03,
      zMode: p.zMode || 'scale_true',
      flipX: typeof p.flipX !== 'undefined' ? !!p.flipX : false,
      flipY: typeof p.flipY !== 'undefined' ? !!p.flipY : false,
      sizeLabel: p.sizeLabel || null
    };

    payload.kmMode = payload.km === 0 ? 'gpx' : 'radius';

    const gpx = p.gpx || LAST_GPX || null;

    if (gpx && Array.isArray(gpx.points) && gpx.points.length) {
      const MAX = 1500;
      let pts = gpx.points;

      if (pts.length > MAX) {
        const step = Math.ceil(pts.length / MAX);
        pts = pts.filter((_, i) => i % step === 0);
      }

      payload.gpx = {
        name: gpx.name || 'route.gpx',
        points: pts
      };
    } else {
      payload.gpx = null;
    }

    return payload;
  }

  function ensureHiddenInRealProductForm() {
    const form = document.querySelector('product-form form');
    if (!form) return null;

    let input = form.querySelector('#Geo3DJson');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.id = 'Geo3DJson';
      input.name = 'properties[_geo3d_json]';
      input.value = '';
      form.appendChild(input);
    }

    input.name = 'properties[_geo3d_json]';

    return input;
  }

  function syncGeo3DHidden() {
    killGhostGeo3DJson();

    const input =
      document.querySelector('product-form form #Geo3DJson') ||
      ensureHiddenInRealProductForm();

    if (!input) return;

    const s = window.__geo3dState || {};
    const raw = s[UID] || null;

    const payload = buildFinalPayload(raw);
    if (!payload) return;

    input.value = JSON.stringify(payload);

    console.log('[Geo3D] payload final carrito:', payload);
  }

  function attach() {
    killGhostGeo3DJson();
    ensureHiddenInRealProductForm();

    window.addEventListener('geo3d:params', syncGeo3DHidden, true);

    window.addEventListener(
      'geo3d:gpx',
      function (e) {
        const d = (e && e.detail) || {};
        if (d.uid && d.uid !== UID) return;

        LAST_GPX = d.gpx ? d.gpx : null;

        window.__geo3dState = window.__geo3dState || {};
        window.__geo3dState[UID] = window.__geo3dState[UID] || { uid: UID };

        window.__geo3dState[UID].gpx = LAST_GPX;
        window.__geo3dState[UID].km = 0;

        if (d.trackColor) {
          window.__geo3dState[UID].trackColor = d.trackColor;
        }

        syncGeo3DHidden();
      },
      true
    );

    window.addEventListener(
      'geo3d:track',
      function (e) {
        const d = (e && e.detail) || {};
        if (d.uid && d.uid !== UID) return;

        window.__geo3dState = window.__geo3dState || {};
        window.__geo3dState[UID] = window.__geo3dState[UID] || { uid: UID };
        window.__geo3dState[UID].trackColor =
          d.trackColor || window.__geo3dState[UID].trackColor || null;

        syncGeo3DHidden();
      },
      true
    );

    document.addEventListener('submit', syncGeo3DHidden, true);

    setTimeout(syncGeo3DHidden, 300);
    setTimeout(syncGeo3DHidden, 900);
    setTimeout(syncGeo3DHidden, 1800);

    console.log('[Geo3D] ghost guard + sync + GPX fixes activos ✅');
  }

  document.addEventListener('DOMContentLoaded', () => {
    killGhostGeo3DJson();
    setTimeout(killGhostGeo3DJson, 300);
    setTimeout(killGhostGeo3DJson, 1200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();